/* eslint-disable react/no-redundant-should-component-update */
/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import styled from 'styled-components';
import isEqual from 'lodash/isEqual';

import FetchTrigger from './FetchTrigger';
import BaseChannel from './Channel';
import { getZapNumber } from '../../helpers/getZapNumber';

const Channel = styled(BaseChannel)`
  height: 130px;
  border: 1px solid ${props => props.theme.tvGuide.border};
  border-top: none;
  box-sizing: border-box;
`;

const Wrapper = styled.div``;

export default class Channels extends React.Component {
  displayName = 'Channels';

  shouldComponentUpdate(nextProps) {
    return !isEqual(this.props, nextProps);
  }

  render() {
    const { channels, perPage, fetch, className } = this.props;

    return (
      <Wrapper className={className}>
        {Object.values(channels).map((channel, index) => {
          const zapNumber = getZapNumber(channel);
          const logoUrl = channel.logoUrl || channel.LogoUrl;
          return (
            <div key={`Channel${index}`}>
              <FetchTrigger
                index={index}
                perPage={perPage}
                data={channels}
                method={fetch}
              />
              <Channel imageUrl={logoUrl} zapNumber={zapNumber} />
            </div>
          );
        })}
      </Wrapper>
    );
  }
}
